import React from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const Store = ({ user, config, cmsSourceFirebase, actions, match }) => {
    const storeUrl = config?.config?.partner_map?.store ?? '';

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <div className='my-5 text-center'>
                <h3>
                    Redirecting to the Store:
                    <a href={storeUrl}>{storeUrl ? window.location.replace(storeUrl) : null}</a>
                </h3>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Store);
